import React, { Component } from "react";
import {
  Wrapper,
  Card,
  Input,
  CardBody,
  Row,
  Copy,
  Spin
} from "app/NativeComponents/common";
import { Select } from "app/NativeComponents/snippets";

import {
  /*common functions */
  focusNextField,
  getStateName
} from "app/NativeActions";

class EditForwardingNumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      area_code: "",
      forwarding_number: this.props.fields.forwarding_number,
      custom_number: "",
      forwarding_number_options: this.assembleForwardingNumberArray(
        props.available_forwarding_numbers
      )
    };
  }

  assembleForwardingNumberArray(available_forwarding_numbers) {
    let forwarding_number_options = [];
    if (available_forwarding_numbers) {
      for (let i = 0; i < available_forwarding_numbers.length; i++) {
        forwarding_number_options.push({
          label: available_forwarding_numbers[i],
          value: available_forwarding_numbers[i]
        });
      }
    }
    forwarding_number_options.push({
      label: "New Phone Number",
      value: "new_number"
    });

    return forwarding_number_options;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.available_forwarding_numbers !==
      this.props.available_forwarding_numbers
    ) {
      this.setState({
        forwarding_number_options: this.assembleForwardingNumberArray(
          this.props.available_forwarding_numbers
        )
      });

      if (
        this.props.available_forwarding_numbers &&
        this.props.available_forwarding_numbers.length > 0 &&
        !this.state.forwarding_number
      ) {
        this.setState({
          forwarding_number: this.props.available_forwarding_numbers[0]
        });
      }
    }
  }

  componentDidMount() {
    this.props.getTeamPhoneNumbers({ token: this.props.token });
  }

  renderPhoneInput() {
    if (this.state.forwarding_number == "new_number") {
      return (
        <Input
          ref="new_forwarding_number"
          name="new_forwarding_number"
          mask_type={"cel-phone"}
          returnKeyType={"done"}
          blurOnSubmit={true}
          autoCapitalize="none"
          keyboardType="numeric"
          placeholder="Phone Number"
          onChange={value => {
            this.setState({
              custom_number: value
            });
            this.props.updateField({ prop: "forwarding_number", value });
          }}
          onSubmitEditing={() => {}}
          value={this.state.custom_number}
          type="text"
          mask={"(999) 999-9999"}
        />
      );
    }
  }

  renderForwardingNumbers() {
    if (this.props.team_phone_numbers_loading) {
      return (
        <Card>
          <CardBody>
            <Row>
              <Spin size="small" />
              <Copy style={{ marginLeft: 10 }}>Loading...</Copy>
            </Row>
          </CardBody>
        </Card>
      );
    }

    return (
      <Card>
        <Select
          item_ref={"forwarding_number"}
          items={this.state.forwarding_number_options}
          title="Forwarding Number"
          label="Select a phone number to forward calls"
          value={this.state.forwarding_number}
          text={
            this.state.forwarding_number === "new_number"
              ? "New Phone Number"
              : this.state.forwarding_number
              ? this.state.forwarding_number
              : "Not Selected"
          }
          onSelect={item => {
            this.setState({
              forwarding_number: item
            });
            this.props.updateField({ prop: "forwarding_number", value: item });
          }}
        />
        {this.renderPhoneInput()}
      </Card>
    );
  }

  render() {
    return <Wrapper>{this.renderForwardingNumbers()}</Wrapper>;
  }
}

export default EditForwardingNumber;
